import { getQueryWithParams, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { GET_PROFILE } from "src/components/graphql/GraphQLquery";
import { LIST_SPECIALIZATIONS } from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";
import { ADD_CLINIC_BANK_DETAILS, UPDATE_PROFILE, VERIFY_TOKEN } from "src/components/graphql/GraphQLmutation";
import { postMutationUnAuth } from "src/components/ApolloConnection/UnauthorizedConnection/ApolloProviderSignup";

export async function listSpecializations(search) {
  try {
    const response = await getQueryWithParams(LIST_SPECIALIZATIONS(String(search)));

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch specializations");
    }

    const result = response?.data?.listSpecializations;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch specializations");
    }

    // Success case
    if (result?.data && result.data.length > 0) {
      snackbar({
        message: result?.message || "Doctor's specializations fetched successfully.",
        color: "success"
      });
      return result.data;
    }
    return [];
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger"
    });
    console.error("Error at listSpecializations:", e);
    return null;
  }
}

export async function getMyProfile() {
  try {
    const response = await getQueryWithParams(GET_PROFILE);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch profile");
    }

    const result = response?.data?.getMyProfile;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch profile");
    }

    // Success case
    if (result?.data) {
      if (result.data.specialization) {
        sessionStorage.setItem("specialization", result.data.specialization[0]);
      }
      return result.data;
    }
    throw new Error("No profile data returned");
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger"
    });
    console.error("Error at getMyProfile:", e);
    return null;
  }
}

export async function updateProfile(data) {
  try {
    const response = await postMutation(UPDATE_PROFILE, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to update profile");
    }

    const result = response?.data?.updateEmployee;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to update profile");
    }

    // Success case
    snackbar({
      message: result?.message || "Profile updated successfully.",
      color: "success"
    });
    return result?.data || true;
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger"
    });
    console.error("Error at updateProfile:", e);
    return null;
  }
}

export async function verifyTurnstileToken(data) {
  try {
    const response = await postMutationUnAuth(VERIFY_TOKEN, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to verify token");
    }

    const result = response?.data?.verifyTurnstile;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to verify token");
    }

    // Success case
    return result?.data;
  } catch (error) {
    console.error("Error at verifyTurnstileToken:", error);
    return null;
  }
}

export async function addClinicBankDetails(data) {
  try {
    const response = await postMutation(ADD_CLINIC_BANK_DETAILS, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to add bank details");
    }

    const result = response?.data?.addClinicBankDetails;

    if (result?.statusCode >= 200 && result.statusCode < 300) {
      snackbar({ message: result.message || "Bank details added successfully", color: "success" });
      return result.data;
    } else {
      throw new Error(result?.message || "Failed to add bank details");
    }
  } catch (e) {
    snackbar({ message: e.message || "Failed to add bank details", color: "danger" });
    console.error("Error at addClinicBankDetails:", e);
    return null;
  }
}